import { render, staticRenderFns } from "./BookingStatistics.vue?vue&type=template&id=65bf8d54&"
import script from "./BookingStatistics.vue?vue&type=script&lang=ts&"
export * from "./BookingStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports